import { Button, DatePicker, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ErrorToast,
  ShowInputError,
  SuccessToast,
} from "../../../widgets/AppToast";
import TextArea from "antd/es/input/TextArea";
import { ApiURL } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import moment from "moment";
import { post } from "../../../services/services";
import dayjs from "dayjs";

const wind_conditions = [
  "0 Beaufort - Calm",
  "1 Beaufort - Light Air",
  "2 Beaufort - Light Breeze",
  "3 Beaufort - Gentle Breeze",
  "4 Beaufort - Moderate Breeze",
  "5 Beaufort - Fresh Breeze",
  "6 Beaufort - Strong Breeze",
  "7 Beaufort - Near Gale",
  "8 Beaufort - Gale",
  "9 Beaufort - Strong Gale",
  "10 Beaufort - Storm",
  "11 Beaufort - Violent Storm",
  "12 Beaufort - Hurricane",
];

const weather_details = [
  "Calm (glassy) - (0 – 0)m height",
  "Calm (rippled) - 0 – 0.10m height",
  "Smooth (wavelets) - 0.10 – 0.50m height",
  "Slight - 0.50 – 1.25m height",
  "Moderate - 1.25 – 2.50m height",
  "Rough - 2.50 – 4.00m height",
  "Very Rough - 4.00 – 6.00m height",
  "High - 6.00 – 9.00m height",
  "Very High - 9.00 – 14.00m height",
  "Phenomenal - 14m height",
];

const visibility_Data = [
  "0 - Less than 50 m (less than 55 yd.)",
  "1 - 50 m but less than 200 m",
  "2 - 200 m but less than 500 m",
  "3 - 500 m but less than 1 km",
  "4 - 1 km but less than 2 km",
  "5 - 2 km but less than 4 km (1 nm but less than 2 nm)",
  "6 - 4 km but less than 10 km (2 nm but less than 5 nm)",
  "7 - 10 km but less than 20 km (5 nm but less than 11 nm)",
  "8 - 20 km but less than 50 km (11 nm but less than 27 nm)",
  "9 - 50 km or greater (27 nm or greater)",
];

function AddDeckLog() {
  const navigate = useNavigate();
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [sea_condition, set_sea_condition] = useState("");
  const [wind_condition, set_wind_condition] = useState([]);
  const [swell, set_swell] = useState("");
  const [position_in_latitude, set_position_in_latitude] = useState("");
  const [position_in_longitude, set_position_in_longitude] = useState("");
  const [hours_Underway, set_Hours_Underway] = useState("");
  const [speed, set_speed] = useState("");
  const [speed_on_ground, set_speed_on_ground] = useState("");
  const [distance_covered, set_distance_covered] = useState("");
  const [voyage_qty_of_cargo, set_voyage_qty_of_cargo] = useState("");
  const [qty_of_ballast, set_qty_of_ballast] = useState("");
  const [port_from, set_port_from] = useState("");
  const [port_to, set_port_to] = useState("");
  const [instructed_speed, set_instructed_speed] = useState("");
  const [hsfo_consumption, set_hsfo_consumption] = useState("");
  const [vlsfo_consumption, set_vlsfo_consumption] = useState("");
  const [lsmgo_consumption, set_lsmgo_consumption] = useState("");
  const [other_consumption, set_other_consumption] = useState("");
  const [loaded_ballast, set_loaded_ballast] = useState("");
  const [draft, set_draft] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [course_heading, set_course_heading] = useState("");
  const [logDate, set_LogDate] = useState(null);
  const [distance_to_go, set_Distance_To_Go] = useState("");
  const [vessel_status, set_vessel_status] = useState("");
  const [lo_consumption, set_lo_consumption] = useState("");
  const [fw_consumption, set_fw_consumption] = useState("");
  const [swell_direction, set_swell_direction] = useState("");
  const [visibility, set_visibility] = useState("");

  console.table([position_in_latitude, position_in_longitude]);

  const ADD_DECK_LOGBOOK_APIS = async () => {
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("sea_condition", sea_condition || "");
    FORM_DATA.append(
      "voyage_id",
      staff_dashboard?.voyage_details?.[0]?.id || ""
    );
    FORM_DATA.append("wind_condition", wind_condition || "");
    FORM_DATA.append("swell", swell || "");
    FORM_DATA.append("latitude", position_in_latitude || "");
    FORM_DATA.append("longitude", position_in_longitude || "");
    FORM_DATA.append("speed_gps", Number(speed) || 0);
    FORM_DATA.append("speed_through_water", Number(speed_on_ground) || 0);
    FORM_DATA.append("distance_covered", Number(distance_covered) || 0);
    FORM_DATA.append("distance_to_go", Number(distance_to_go) || 0);
    FORM_DATA.append("course", Number(course_heading) || 0);
    FORM_DATA.append("hours_underway", hours_Underway);
    FORM_DATA.append("vlsfo_consumption", vlsfo_consumption || 0);
    FORM_DATA.append("lsmgo_consumption", lsmgo_consumption || 0);
    FORM_DATA.append("other_consumption", other_consumption || 0);
    FORM_DATA.append("hsfo_consumption", hsfo_consumption || 0);
    FORM_DATA.append("voyage_type", loaded_ballast || "");
    FORM_DATA.append("draft", Number(draft) || 0);
    FORM_DATA.append("qty_of_cargo", Number(voyage_qty_of_cargo) || 0);
    FORM_DATA.append("qty_of_ballast", Number(qty_of_ballast) || 0);
    FORM_DATA.append("port_from", port_from || "");
    FORM_DATA.append("port_to", port_to || "");
    FORM_DATA.append("instructed_speed", Number(instructed_speed) || 0);
    FORM_DATA.append("deck_comment", free_Text || "");
    FORM_DATA.append("log_date_time", logDate || "");
    FORM_DATA.append("vessel_status", vessel_status || "");
    FORM_DATA.append("lube_orb", lo_consumption || "");
    FORM_DATA.append("fw_rob", fw_consumption || "");
    FORM_DATA.append("swell_direction", swell_direction || "");
    FORM_DATA.append("visibility", visibility || "");

    post(ApiURL.create_deck_log, FORM_DATA).then((res) => {
      if (res?.status === true) {
        SuccessToast("Success message!!", res?.message);
        navigate(`/edit-deck-log/${btoa(res.deck_log_id)}`);
        set_loader(false);
      } else {
        ErrorToast("Error message", res?.message);
        const errors = res?.errors || {};
        set_errors(errors);
        set_loader(false);
      }
    });
  };

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_draft(parsedData?.voyage_details[0]?.draft);
    set_loaded_ballast(parsedData?.voyage_details[0]?.voyage_type);
    set_staff_dashboard(parsedData);
  }, []);

  return (
    <>
      <VoyageDetails staff_dashboard={staff_dashboard?.voyage_details} />
      <div className="white-container">
        <br />
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                onChange={onChangeDateTime}
                style={{ width: "100%" }}
              />
              {errors.log_date_time && (
                <ShowInputError errorMessage={errors.log_date_time} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>vessel status</label>
              <Select
                // value={vessel_status}
                placeholder=" -- Select of  vessel status  -- "
                style={{ width: "100%" }}
                onChange={(value) => set_vessel_status(value)}
              >
                <Select.Option value="At Sea">At Sea</Select.Option>
                <Select.Option value="At Anchor">At Anchor</Select.Option>
                <Select.Option value="At Port">At Port</Select.Option>
              </Select>
              {errors.vessel_status && (
                <ShowInputError errorMessage={errors.vessel_status} />
              )}
            </div>
          </div>
        </div>
        <h3>Weather Details </h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Sea Condition</label>
              <Select
                value={sea_condition}
                placeholder=" -- Select of  Sea Condition  -- "
                style={{ width: "100%" }}
                onChange={(value) => set_sea_condition(value)}
              >
                {weather_details?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
              {errors.sea_condition && (
                <ShowInputError errorMessage={errors.sea_condition} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Wind Force</label>
              <Select
                placeholder="--select of Wind Force --"
                style={{ width: "100%" }}
                value={wind_condition}
                onChange={(value) => set_wind_condition(value)}
              >
                {wind_conditions?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
              {errors.wind_condition && (
                <ShowInputError errorMessage={errors.wind_condition} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Swell Height (In meters)</label>
              <Input
                value={swell}
                placeholder="Swell Height"
                onChange={(e) => set_swell(e.target.value)}
              />
              {errors.swell && <ShowInputError errorMessage={errors.swell} />}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Swell Direction</label>
              <Input
                value={swell_direction}
                placeholder="Swell Direction"
                onChange={(e) => set_swell_direction(e.target.value)}
              />
              {errors.swell_direction && (
                <ShowInputError errorMessage={errors.swell_direction} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Visibility</label>
              <Select
                placeholder="--select of Visibility --"
                style={{ width: "100%" }}
                value={visibility}
                onChange={(value) => set_visibility(value)}
              >
                {visibility_Data?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
              {errors.visibility && (
                <ShowInputError errorMessage={errors.visibility} />
              )}
            </div>
          </div>
        </div>
        <br />

        <h3>Position (GPS & others)</h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Latitude</label>
              <Input
                value={position_in_latitude}
                placeholder="Latitude"
                onChange={(e) => set_position_in_latitude(e.target.value)}
              />
              {errors.position_in_latitude && (
                <ShowInputError errorMessage={errors.position_in_latitude} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Longitude</label>
              <Input
                value={position_in_longitude}
                placeholder="Longitude"
                onChange={(e) => set_position_in_longitude(e.target.value)}
              />
              {errors.position_in_longitude && (
                <ShowInputError errorMessage={errors.position_in_longitude} />
              )}
            </div>
          </div>
        </div>
        <br />

        <h3>Speed & Distance</h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Speed through GPS (In knots)</label>
              <Input
                value={speed}
                placeholder="Speed through GPS"
                onChange={(e) => set_speed(e.target.value)}
              />
              {errors.speed && <ShowInputError errorMessage={errors.speed} />}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Speed through Water (In knots)</label>
              <Input
                value={speed_on_ground}
                placeholder="Speed through Water"
                onChange={(e) => set_speed_on_ground(e.target.value)}
              />
              {errors.speed_on_ground && (
                <ShowInputError errorMessage={errors.speed_on_ground} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Distance Covered (In nautical miles)</label>
              <Input
                value={distance_covered}
                placeholder="Distance Covered"
                onChange={(e) => set_distance_covered(e.target.value)}
              />
              {errors.distance_covered && (
                <ShowInputError errorMessage={errors.distance_covered} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Distance to go (In nautical miles)</label>
              <Input
                value={distance_to_go}
                placeholder="Distance To Go"
                onChange={(e) => set_Distance_To_Go(e.target.value)}
              />
              {errors.distance_to_go && (
                <ShowInputError errorMessage={errors.distance_to_go} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Course/Heading (In degrees)</label>
              <Input
                value={course_heading}
                placeholder="Course/Heading"
                onChange={(e) => set_course_heading(e.target.value)}
              />
              {errors.course_heading && (
                <ShowInputError errorMessage={errors.course_heading} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Hours Underway</label>
              <Input
                value={hours_Underway}
                placeholder="Hours Underway"
                onChange={(e) => set_Hours_Underway(e.target.value)}
              />
              {errors.hours_Underway && (
                <ShowInputError errorMessage={errors.hours_Underway} />
              )}
            </div>
          </div>
        </div>
        <br />

        <h3>Voyage Details</h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Loaded/ Ballast</label>
              <Input
                disabled
                value={loaded_ballast}
                placeholder="Loaded/ Ballast"
                onChange={(e) => set_loaded_ballast(e.target.value)}
              />
              {errors.loaded_ballast && (
                <ShowInputError errorMessage={errors.loaded_ballast} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Draft (In meter)</label>
              <Input
                disabled
                value={draft}
                placeholder="Draft"
                onChange={(e) => set_draft(e.target.value)}
              />
              {errors.draft && <ShowInputError errorMessage={errors.draft} />}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Quantity of Cargo</label>
              <Input
                value={voyage_qty_of_cargo}
                placeholder="Quantity of Cargo"
                onChange={(e) => set_voyage_qty_of_cargo(e.target.value)}
              />
              {errors.voyage_qty_of_cargo && (
                <ShowInputError errorMessage={errors.voyage_qty_of_cargo} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Quantity of Ballast</label>
              <Input
                value={qty_of_ballast}
                placeholder="Quantity of Ballast"
                onChange={(e) => set_qty_of_ballast(e.target.value)}
              />
              {errors.qty_of_ballast && (
                <ShowInputError errorMessage={errors.qty_of_ballast} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Port From</label>
              <Input
                value={port_from}
                placeholder="Port From"
                onChange={(e) => set_port_from(e.target.value)}
              />
              {errors.port_from && (
                <ShowInputError errorMessage={errors.port_from} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Port To</label>
              <Input
                value={port_to}
                placeholder="Port To"
                onChange={(e) => set_port_to(e.target.value)}
              />
              {errors.port_to && (
                <ShowInputError errorMessage={errors.port_to} />
              )}
            </div>
          </div>
        </div>

        <h3>Charterer Details</h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Instructed Speed</label>
              <Input
                value={instructed_speed}
                placeholder="Instructed Speed"
                onChange={(e) => set_instructed_speed(e.target.value)}
              />
              {errors.instructed_speed && (
                <ShowInputError errorMessage={errors.instructed_speed} />
              )}
            </div>
          </div>
        </div>

        <h3>Fuel ROB</h3>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>HSFO ROB</label>
              <Input
                value={hsfo_consumption}
                placeholder="HSFO fuel Consumption"
                onChange={(e) => set_hsfo_consumption(e.target.value)}
              />
              {errors.hsfo_consumption && (
                <ShowInputError errorMessage={errors.hsfo_consumption} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>VLSFO ROB</label>
              <Input
                value={vlsfo_consumption}
                placeholder="VLSFO fuel Consumption"
                onChange={(e) => set_vlsfo_consumption(e.target.value)}
              />
              {errors.vlsfo_consumption && (
                <ShowInputError errorMessage={errors.vlsfo_consumption} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>LO ROB</label>
              <Input
                value={lo_consumption}
                placeholder="LO fuel Consumption"
                onChange={(e) => set_lo_consumption(e.target.value)}
              />
              {errors.lo_consumption && (
                <ShowInputError errorMessage={errors.lo_consumption} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>FW ROB</label>
              <Input
                value={fw_consumption}
                placeholder="VLSFO fw Consumption"
                onChange={(e) => set_fw_consumption(e.target.value)}
              />
              {errors.fw_consumption && (
                <ShowInputError errorMessage={errors.fw_consumption} />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>LSMGO ROB</label>
              <Input
                value={lsmgo_consumption}
                placeholder="LSMGO fuel Consumption"
                onChange={(e) => set_lsmgo_consumption(e.target.value)}
              />
              {errors.lsmgo_consumption && (
                <ShowInputError errorMessage={errors.lsmgo_consumption} />
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>OTHER ROB</label>
              <Input
                value={other_consumption}
                placeholder="Other fuel Consumption"
                onChange={(e) => set_other_consumption(e.target.value)}
              />
              {errors.other_consumption && (
                <ShowInputError errorMessage={errors.other_consumption} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Deck Logbook Comments</label>
              <TextArea
                rows={6}
                placeholder="Deck Logbook Comments"
                maxLength={1000}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="input-box" style={{ marginTop: "15px" }}>
            <Button
              loading={loader}
              type="primary"
              className="save_btn"
              style={{ color: "white", marginLeft: "10px" }}
              onClick={ADD_DECK_LOGBOOK_APIS}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddDeckLog;
